module.exports = __webpack_public_path__ + "img/img2.a705014f.jpg";